import { buildQueryString } from "../../base";
import { upload } from "../../base/store/services";
import constants from "./constants";

export const getKU55Data = async (
  brfCompanyId,
  forYear,
  isCorrection,
  excludeIds,
  customCapitalAdditions,
) => {
  const q = buildQueryString({
    for_date: `${forYear}-01-01`,
    isCorrection: isCorrection,
    exclude_ids: excludeIds,
  });

  const convertedCapitalAdditions = {};

  if (customCapitalAdditions?.length) {
    try {
      for (const cc of customCapitalAdditions) {
        const year = cc.as_of_date?.split("-")[0];

        if (convertedCapitalAdditions[year]) {
          convertedCapitalAdditions[year] += parseInt(cc.value);
        } else {
          convertedCapitalAdditions[year] = parseInt(cc.value);
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  return await upload({
    url: `${constants.GET_KU55_URL}${brfCompanyId}/?${q}`,
    data: {
      custom_capital_addons: Object.keys(convertedCapitalAdditions).length
        ? convertedCapitalAdditions
        : undefined,
    },
  });
};

export const insertKU55Logs = async (brfCompanyId, transData) => {
  return await upload({
    url: `${constants.POST_KU55_LOG_URL}${brfCompanyId}/`,
    data: { data: transData },
  });
};
